// global axios, Cookies
const initBasket = () => {
  const productBasket = document.querySelector('.product-basket');
  if (productBasket) {
    const updateBasketCount = () => {
      productBasket.querySelector('.product-basket__nr').textContent =
        productBasket.querySelectorAll('.product-basket__item').length;
    };
    updateBasketCount();

    const closeBasket = () => {
      const content = productBasket.querySelector('.product-basket__content');
      slideUp(content, 300);
      setTimeout(() => productBasket.classList.remove('is-open'), 300);
    };

    attachEvent('.open-product-basket', 'click', () => {
      const content = productBasket.querySelector('.product-basket__content');

      if (productBasket.classList.contains('is-open')) {
        closeBasket();
      } else {
        productBasket.classList.add('is-open');
        setTimeout(() => slideDown(content, 300, 'block'), 300);
      }
    });

    document.addEventListener('click', (e) => {
      if (!productBasket.contains(e.target) && productBasket.classList.contains('is-open')) closeBasket();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && productBasket.classList.contains('is-open')) closeBasket();
    });

    attachEvent('.product-basket__remove', 'click', (ev) => {
      const parent = ev.target.closest('.product-basket__item');

      slideUp(parent, 300);
      setTimeout(() => {
        parent.remove();
        updateBasketCount();
      }, 300);
    });
  }
};

const axiosBasket = (id = 0, actionTo = 'add', number = 1) => {
  axios
    .post(localData.apiURL, {
      action: 'addItemToInquiry',
      product_id: id,
      actionTo,
      number,
    })
    .then((response) => {
      if (response.data.data.html_cart && actionTo !== 'remove') {
        const cart = document.querySelector('.cart-box');
        if (cart) {
          setTimeout(() => {
            cart.querySelector('.product-basket')?.classList.add('is-active');
          }, 250);
          cart.innerHTML = response.data.data.html_cart;
          initBasket();
        }
      }

      if ((actionTo === 'add' || actionTo === 'remove') && id) {
        dataLayerSend(response.data.data.data_layer);
      }
    })
    .catch((error) => console.error('Axios error:', error));
};
window.addEventListener('load', () => {
  const cartBox = document.querySelector('.cart-box');
  if (cartBox && Cookies.get('cart')) {
    axiosBasket();
    initBasket();
  }
  attachEvent('.product-basket__remove', 'click', (ev) => {
    axiosBasket(Number(ev.target.closest('.product-basket__item').dataset.id), 'remove');
  });
  attachEvent('.basket-item__remove', 'click', (ev) => {
    axiosBasket(Number(ev.target.closest('.basket-item').dataset.id), 'remove', -1);
  });
  attachEvent('.basket-items__remove', 'click', () => {
    axios
      .post(localData.apiURL, {
        action: 'removeCart',
      })
      .catch((error) => console.error('Axios error:', error));
  });
  attachEvent('.basket-item__amount', 'input', (ev) => {
    axiosBasket(Number(ev.target.closest('.basket-item').dataset.id), 'change', ev.target.value);
  });
  attachEvent('.basket-item__plus, .basket-item__minus', 'click', (ev) => {
    axiosBasket(
      Number(ev.target.closest('.basket-item').dataset.id),
      'change',
      ev.target.closest('.basket-item').querySelector('input').value,
    );
  });
  attachEvent('.product-basket .product-basket__buttons a', 'click', async (ev) => {
    ev.preventDefault();
    const dataLayer = await axios
      .post(localData.apiURL, {
        action: 'getDataLayer',
      })
      .catch((error) => console.error('Axios error:', error));
    if (dataLayer?.data?.data) {
      dataLayerSend([dataLayer.data.data]);
      setTimeout(() => {
        window.location = ev.target.closest('a').href;
      }, 200);
    }
  });
  attachEvent('.cart-box button.open-product-basket', 'click', async (ev) => {
    ev.preventDefault();
    try {
      const response = await axios.post(localData.apiURL, {
        action: 'getDataLayer',
        event: 'view_cart',
      });
      setTimeout(() => {
        if (document.querySelector('.product-basket.is-open') && response?.data?.data) {
          dataLayerSend([response.data.data]);
        }
      }, 300);
    } catch (error) {
      console.error('Axios error:', error);
    }
  });
});
